import Config from '@qover/utils/src/Config';
import { TripType } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import Step, { Path } from '../domain/Step';
import { nextButtonMessages, breadcrumbMessages } from '../travel.messages';
import {
  insurersValidation,
  policyholderValidation,
  summaryValidation,
  tripDurationValidator,
} from './trValidation';
import {
  createMainProduct,
  pushGetAQuoteGeoTrip,
  // pushGetAQuoteMaxTripDuration,
  pushGetAQuoteTripDuration,
} from '../domain/customDataLayer';

export const maxAdults = {
  [TripType.TRIP_TYPE_SINGLE_TRIP]: 20,
  [TripType.TRIP_TYPE_MULTI_TRIP]: 2,
  [TripType.TRIP_TYPE_YEAR_TRIP]: 2,
  [TripType.TRIP_TYPE_UNSPECIFIED]: 2,
};

export const maxChildren = {
  [TripType.TRIP_TYPE_SINGLE_TRIP]: 20,
  [TripType.TRIP_TYPE_MULTI_TRIP]: 8,
  [TripType.TRIP_TYPE_YEAR_TRIP]: 8,
  [TripType.TRIP_TYPE_UNSPECIFIED]: 8,
};

export const BASE_PATH = Config.getApiUrl('travel');

export const STEPS = [
  new Step({
    initialPath: 'trip-duration',
    paths: [
      new Path({
        path: 'trip-duration',
        showBottomNav: false,
        ecommerce: pushGetAQuoteTripDuration,
        validate: tripDurationValidator,
      }),
      new Path({ path: 'create-draft', showBottomNav: false }),
      // new Path({ path: 'needs', showBottomNav: false }),
      new Path({
        path: 'short-trip-location',
        showBottomNav: false,
        nextPath: 'quote',
        ecommerce: pushGetAQuoteGeoTrip,
      }),
      // new Path({
      //   path: 'max-trip-duration',
      //   showBottomNav: false,
      //   nextPath: 'quote',
      //   ecommerce: pushGetAQuoteMaxTripDuration,
      // }),
    ],
    label: breadcrumbMessages.needs,
  }),
  new Step({
    initialPath: 'quote',
    paths: [
      new Path({
        path: 'quote',
        nextPath: 'options',
        showBottomNav: false,
        ecommerce: createMainProduct,
      }),
      // new Path({
      //   path: 'quote-multi-trip',
      //   nextPath: 'options',
      //   showBottomNav: false,
      //   ecommerce: createMainProduct,
      // }),
      // new Path({
      //   path: 'quote-expat',
      //   nextPath: 'options',
      //   showBottomNav: false,
      //   ecommerce: createMainProduct,
      // }),
      new Path({ path: 'options', nextPath: 'insurers' }),
    ],
    label: breadcrumbMessages.quote,
  }),
  new Step({
    initialPath: 'insurers',
    paths: [
      new Path({
        path: 'insurers',
        nextPath: 'finalization',
        validate: insurersValidation,
        buttonTitle: nextButtonMessages.continue,
      }),
    ],
    label: breadcrumbMessages.insurers,
  }),
  new Step({
    initialPath: 'finalization',
    paths: [
      new Path({
        path: 'finalization',
        nextPath: 'summary',
        validate: policyholderValidation,
        buttonTitle: nextButtonMessages.continue,
      }),
      new Path({
        path: 'summary',
        validate: summaryValidation,
        buttonTitle: nextButtonMessages.payNow,
        showBottomNav: false,
      }),
      new Path({
        path: 'payment',
        fetchPrices: false,
        fetchTerms: false,
        showBottomNav: false,
        showBreadcrumb: false,
        showFaq: false,
        showFooter: false,
        showLegalMentions: false,
      }),
      new Path({
        path: 'confirmation',
        fetchPrices: false,
        fetchTerms: false,
        showBreadcrumb: false,
        showFaq: false,
      }),
    ],
    label: breadcrumbMessages.finalization,
  }),
];

export const MOBILE_STEPS = STEPS;
